module.exports = __webpack_public_path__ + "media/images/symbol-defs-bf2fac02.svg";